import { render, staticRenderFns } from "./courseLearningRatesixth.vue?vue&type=template&id=00bfbed8&scoped=true"
import script from "./courseLearningRatesixth.vue?vue&type=script&lang=js"
export * from "./courseLearningRatesixth.vue?vue&type=script&lang=js"
import style0 from "./courseLearningRatesixth.vue?vue&type=style&index=0&id=00bfbed8&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00bfbed8",
  null
  
)

export default component.exports